import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import SuperadminDashboard from './pages/superadmin/Dashboard';
import SuperadminOfficerDashboard from './pages/superadmin/Officers';
import SuperadminSalariesDashboard from './pages/superadmin/Salaries';
import SuperadminFinance from './pages/superadmin/Finance';
import OfficerSalariesDashboard from './pages/officer/Salaries';
import OfficerDashboard from './pages/officer/Dashboard';
import SuperadminTasks from './pages/superadmin/TaskManagement';
import OfficerTasks from './pages/officer/TaskDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/superadmin/dashboard"
          element={
            <ProtectedRoute allowedRole="superadmin">
              <SuperadminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/officers"
          element={
            <ProtectedRoute allowedRole="superadmin">
              <SuperadminOfficerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/salaries"
          element={
            <ProtectedRoute allowedRole="superadmin">
              <SuperadminSalariesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/finance"
          element={
            <ProtectedRoute allowedRole="superadmin">
              <SuperadminFinance />
            </ProtectedRoute>
          }
        />

        <Route
          path="/officer/dashboard"
          element={
            <ProtectedRoute allowedRole="officer">
              <OfficerDashboard />
            </ProtectedRoute>
          }
        />

         <Route
          path="/officer/salaries"
          element={
            <ProtectedRoute allowedRole="officer">
              <OfficerSalariesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/tasks"
          element={
            <ProtectedRoute allowedRole="superadmin">
              <SuperadminTasks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/officer/tasks"
          element={
            <ProtectedRoute allowedRole="officer">
              <OfficerTasks />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
